import { Stack, Typography } from "@mui/material";
import * as React from "react";

export interface TableCellDescriptionProps {
  title: string;
  description: string;
  color?: "default" | "primary" | "secondary" | "error" | "info" | "success" | "warning";
}

const TableCellDescription: React.FC<TableCellDescriptionProps> = ({ title, description, color }) => {
  return (
    <Stack>
      <Typography color={color} fontWeight={500}>
        {title}
      </Typography>
      <Typography color="text.secondary" variant="body2">
        {description}
      </Typography>
    </Stack>
  );
};

export default TableCellDescription;
